<template>
  <div class="home">
    <!-- Header -->
    <header class="header">
      <div class="logo-list">
        <div class="logo"></div>
        <div class="logo-text">HaoXin</div>
      </div>

      <!-- <ul class="nav">
        <li>Home</li>
        <li>Products</li>
        <li>About</li>
        <li>Service</li>
        <li>Contact</li>
      </ul> -->

      <div class="icon icon-whatsapp" @click="contactMe(whatsappUrl)"></div>
    </header>

    <!-- Banner -->
    <section class="banner">
      <div class="banner-content">
        <h1>Professional Manufacturer</h1>

        <p>High Quality Products With Competitive Price.</p>

        <!-- <button>Explore Products</button> -->
      </div>
    </section>

    <!-- Category -->
    <section class="category section">
      <h2>Battery Categories</h2>
      <div class="category-list-box" ref="batteryScrollBox">
        <div class="category-list">
          <div
            class="category-item"
            v-for="item in batteryCategories"
            :key="item.id"
            @click="seeDetail(item.id, item.type)"
          >
            <img :src="item.image" />
            <div class="item-name">{{ item.name }}</div>
          </div>
        </div>
      </div>
    </section>

    <section class="category section">
      <h2>All-in-one Categories</h2>
      <div class="category-list-box" ref="allInOneScrollBox">
        <div class="category-list">
          <div
            class="category-item"
            v-for="item in allInOneCategories"
            :key="item.id"
            @click="seeDetail(item.id, item.type)"
          >
            <img :src="item.image" />
            <div class="item-name">{{ item.name }}</div>
          </div>
        </div>
      </div>
    </section>

    <section class="category section">
      <h2>Portable battery Categories</h2>
      <div class="category-list-box" ref="portableBatteryScrollBox">
        <div class="category-list">
          <div
            class="category-item"
            v-for="item in portableBatteryCategories"
            :key="item.id"
            @click="seeDetail(item.id, item.type)"
          >
            <img :src="item.image" />
            <div class="item-name">{{ item.name }}</div>
          </div>
        </div>
      </div>
    </section>

    <section class="category section">
      <h2>High-Voltage Stackable Battery Categories</h2>
      <div class="category-list-box" ref="highVolBatteryScrollBox">
        <div class="category-list">
          <div
            class="category-item"
            v-for="item in highVolBatteryCategories"
            :key="item.id"
            @click="seeDetail(item.id, item.type)"
          >
            <img :src="item.image" />
            <div class="item-name">{{ item.name }}</div>
          </div>
        </div>
      </div>
    </section>

    <section class="category section">
      <h2>Commercial & Industrial Categories</h2>
      <div class="category-list-box" ref="CAndIScrollBox">
        <div class="category-list">
          <div
            class="category-item"
            v-for="item in CAndICategories"
            :key="item.id"
            @click="seeDetail(item.id, item.type)"
          >
            <img :src="item.image" />
            <div class="item-name">{{ item.name }}</div>
          </div>
        </div>
      </div>
    </section>
    <!-- Products -->

    <!-- Advantage -->
    <section class="advantage">
      <h2>Why Choose Us</h2>

      <div class="advantage-list">
        <div class="advantage-item">
          <h3>10+ Years</h3>
          <p>Manufacturing Experience</p>
        </div>

        <div class="advantage-item">
          <h3>OEM & ODM</h3>
          <p>Customized Solution</p>
        </div>

        <div class="advantage-item">
          <h3>Fast Delivery</h3>
          <p>Global Shipping</p>
        </div>

        <div class="advantage-item">
          <h3>24/7</h3>
          <p>Customer Support</p>
        </div>
      </div>
    </section>

    <!-- About -->
    <section class="about section">
      <div class="about-left"></div>

      <div class="about-right">
        <h2>About Company</h2>

        <p>
          We are a professional manufacturer focusing on high-quality products
          and global export business. Our products are exported to Europe,
          America, Southeast Asia and more than 80 countries.
        </p>

        <!-- <button>Learn More</button> -->
      </div>
    </section>

    <!-- Contact -->
    <section class="contact">
      <h2>Contact Us</h2>
      <div class="wechat-contact">
        <img src="../../public/wechat.jpg" alt="" />
      </div>
      <div class="icon-list">
        <div class="icon icon-whatsapp" @click="contactMe(whatsappUrl)"></div>
        <div class="icon icon-facebook" @click="contactMe(facebookUrl)"></div>
        <div class="icon icon-tiktok" @click="contactMe(tiktokUrl)"></div>
        <div class="icon icon-instagram" @click="contactMe(instagramUrl)"></div>
      </div>
    </section>

    <!-- Footer -->
    <footer class="footer">©2026 HaoXin COMPANY All Rights Reserved.</footer>
  </div>
</template>

<script>
export default {
  name: "MyHome",

  data() {
    return {
      //记录滚动条位置
      scrollPositions: {
        batteryScrollBox: 0,
        allInOneScrollBox: 0,
        highVolBatteryScrollBox: 0,
        CAndIScrollBox: 0,
        portableBatteryScrollBox: 0,
      },
      whatsappUrl: "https://wa.me/8613265700149/",
      facebookUrl: "https://www.facebook.com/share/1EPWp4P2Mg/?mibextid=wwXIfr",
      tiktokUrl:
        "https://www.tiktok.com/@luojiajiapromaxsems?_r=1&_t=ZG-98Wijg98bY1",
      instagramUrl:
        "https://www.instagram.com/luojiajiapromaxsems?igsh=MWNqcWI4NGkxd2pqdA%3D%3D&utm_source=qr",
      batteryCategories: [
        {
          id: "5kwh",
          type: "homeBattery",
          name: "5KWH battery",
          image: require("../../public/prodPImg/pro5kwh/1.jpg"),
        },
        {
          id: "10kwh",
          type: "homeBattery",
          name: "10KWH battery",
          image: require("../../public/prodPImg/pro10kwh/1.jpg"),
        },
        {
          id: "16kwh",
          type: "homeBattery",
          name: "16KWH battery",
          image: require("../../public/prodPImg/pro16kwh/1.jpg"),
        },
        {
          id: "15kwh",
          type: "homeBattery",
          name: "15KWH battery",
          image: require("../../public/prodPImg/pro15kwh/1.jpg"),
        },
        {
          id: "17.4kwh",
          type: "homeBattery",
          name: "17.4KWH battery",
          image: require("../../public/prodPImg/pro17.4kwh/1.jpg"),
        },
        {
          id: "28.7kwh",
          type: "homeBattery",
          name: "28.7KWH battery",
          image: require("../../public/prodPImg/pro28.7kwh/1.jpg"),
        },
        {
          id: "31.7kwh",
          type: "homeBattery",
          name: "31.7KWH battery",
          image: require("../../public/prodPImg/pro31.7kwh/1.jpg"),
        },
        {
          id: "11kwh",
          type: "homeBattery",
          name: "11KWH battery",
          image: require("../../public/prodPImg/pro11kwh/1.jpg"),
        },
        {
          id: "21.5kwh",
          type: "homeBattery",
          name: "21.5KWH battery",
          image: require("../../public/prodPImg/pro21.5kwh/1.jpg"),
        },
        {
          id: "23kwh",
          type: "homeBattery",
          name: "23KWH battery",
          image: require("../../public/prodPImg/pro23kwh/1.jpg"),
        },
        {
          id: "46kwh",
          type: "homeBattery",
          name: "46KWH battery",
          image: require("../../public/prodPImg/pro46kwh/1.jpg"),
        },
      ],

      //工商储
      CAndICategories: [
        {
          id: "64kwh",
          type: "CAndI",
          name: "64KWH battery",
          image: require("../../public/prodPImg/pro64kwh/1.jpg"),
        },
        {
          id: "96kwh",
          type: "CAndI",
          name: "96KWH battery",
          image: require("../../public/prodPImg/pro96kwh/1.jpg"),
        },
        {
          id: "112kwh",
          type: "CAndI",
          name: "112KWH battery",
          image: require("../../public/prodPImg/pro112kwh/1.jpg"),
        },
        {
          id: "144kwh",
          type: "CAndI",
          name: "144KWH battery",
          image: require("../../public/prodPImg/pro144kwh/1.jpg"),
        },
        {
          id: "176kwh",
          type: "CAndI",
          name: "176KWH battery",
          image: require("../../public/prodPImg/pro176kwh/1.jpg"),
        },
        {
          id: "208kwh",
          type: "CAndI",
          name: "208KWH battery",
          image: require("../../public/prodPImg/pro208kwh/1.jpg"),
        },
      ],

      //一体机
      allInOneCategories: [
        {
          id: "3.6kw+5.12kwh",
          type: "allInOne",
          name: "3.6kw+5.12kwh",
          image: require("../../public/prodPImg/pro3.6kw+5.12kwh/1.jpg"),
        },
        {
          id: "3.6kw+7.68kwh",
          type: "allInOne",
          name: "3.6kw+7.68kwh",
          image: require("../../public/prodPImg/pro3.6kw+7.68kwh/1.jpg"),
        },
        {
          id: "6kw+10.24kwh",
          type: "allInOne",
          name: "6kw+10.24kwh",
          image: require("../../public/prodPImg/pro6kw+10.24kwh/1.jpg"),
        },
        {
          id: "6kw+16kwh",
          type: "allInOne",
          name: "6kw+16kwh",
          image: require("../../public/prodPImg/pro6kw+16kwh/1.jpg"),
        },
        {
          id: "12kw+32kwh",
          type: "allInOne",
          name: "12kw+32kwh",
          image: require("../../public/prodPImg/pro12kw+32kwh/1.jpg"),
        },
        {
          id: "us3.6kw+7.68kwh",
          type: "allInOne",
          name: "us3.6kw+7.68kwh",
          image: require("../../public/prodPImg/prous3.6kw+7.68kwh/1.jpg"),
        },
        {
          id: "us7.2kw+10.24kwh",
          type: "allInOne",
          name: "us7.2kw+10.24kwh",
          image: require("../../public/prodPImg/prous7.2kw+10.24kwh/1.jpg"),
        },
        {
          id: "us7.2kw+16kwh",
          type: "allInOne",
          name: "us7.2kw+16kwh",
          image: require("../../public/prodPImg/prous7.2kw+16kwh/1.jpg"),
        },
      ],

      //便携式电池

      portableBatteryCategories: [
        {
          id: "PB2kw+4kwh",
          type: "portableBattery",
          name: "PB2kw+4kwh",
          image: require("../../public/prodPImg/proPB2kw+4kwh/1.jpg"),
        },
        {
          id: "PB1.5kw+3kwh",
          type: "portableBattery",
          name: "PB1.5kw+3kwh",
          image: require("../../public/prodPImg/proPB1.5kw+3kwh/1.jpg"),
        },
        {
          id: "PB1kw+2kwh",
          type: "portableBattery",
          name: "PB1kw+2kwh",
          image: require("../../public/prodPImg/proPB1kw+2kwh/1.jpg"),
        },
        {
          id: "PB1.5kw+2kwh",
          type: "portableBattery",
          name: "PB1.5kw+2kwh",
          image: require("../../public/prodPImg/proPB1.5kw+2kwh/1.jpg"),
        },
      ],

      //高压堆叠式电池
      highVolBatteryCategories: [
        {
          id: "2sets-32.1kwh",
          type: "higVol",
          name: "2sets-32.1kwh",
          image: require("../../public/prodPImg/pro2sets-32.1kwh/1.jpg"),
        },
        {
          id: "4sets-64.3kwh",
          type: "higVol",
          name: "4sets-64.3kwh",
          image: require("../../public/prodPImg/pro4sets-64.3kwh/1.jpg"),
        },
        {
          id: "5sets-80.3kwh",
          type: "higVol",
          name: "5sets-80.3kwh",
          image: require("../../public/prodPImg/pro5sets-80.3kwh/1.jpg"),
        },
        {
          id: "6sets-96.4kwh",
          type: "higVol",
          name: "6sets-96.4kwh",
          image: require("../../public/prodPImg/pro6sets-96.4kwh/1.jpg"),
        },
        {
          id: "7sets-112.5kwh",
          type: "higVol",
          name: "7sets-112.5kwh",
          image: require("../../public/prodPImg/pro7sets-112.5kwh/1.jpg"),
        },
        {
          id: "8sets-128.6kwh",
          type: "higVol",
          name: "8sets-128.6kwh",
          image: require("../../public/prodPImg/pro8sets-128.6kwh/1.jpg"),
        },
        {
          id: "9sets-144.6kwh",
          type: "higVol",
          name: "9sets-144.6kwh",
          image: require("../../public/prodPImg/pro9sets-144.6kwh/1.jpg"),
        },
        {
          id: "10sets-160.7kwh",
          type: "higVol",
          name: "10sets-160.7kwh",
          image: require("../../public/prodPImg/pro10sets-160.7kwh/1.jpg"),
        },
        {
          id: "13sets-208.9kwh",
          type: "higVol",
          name: "13sets-208.9kwh",
          image: require("../../public/prodPImg/pro13sets-208.9kwh/1.jpg"),
        },
        {
          id: "14sets-225kwh",
          type: "higVol",
          name: "14sets-225kwh",
          image: require("../../public/prodPImg/pro14sets-225kwh/1.jpg"),
        },
        {
          id: "15sets-241kwh",
          type: "higVol",
          name: "15sets-241kwh",
          image: require("../../public/prodPImg/pro15sets-241kwh/1.jpg"),
        },
        {
          id: "16sets-257kwh",
          type: "higVol",
          name: "16sets-257kwh",
          image: require("../../public/prodPImg/pro16sets-257kwh/1.jpg"),
        },
      ],
    };
  },
  methods: {
    contactMe(url) {
      window.open(url, "_blank");
    },
    seeDetail(id, type) {
      for (let key in this.scrollPositions) {
        if (this.$refs[key]) {
          this.scrollPositions[key] = this.$refs[key].scrollTop;
        }
      }
      this.$router
        .push({
          path: "/productDetail",
          query: {
            id: id,
            type: type,
          },
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  //  离开页面时：记录当前滚动位置
  deactivated() {},
  // 重新进入页面时：将滚动条复原
  activated() {
    this.$nextTick(() => {
      setTimeout(() => {
        // 遍历刚才存下的所有坐标，依次给对应的 DOM 盒子赋值
        for (let key in this.scrollPositions) {
          if (this.$refs[key]) {
            this.$refs[key].scrollTop = this.scrollPositions[key];
          }
        }
      }, 10); // 50ms 延迟确保所有盒子的 DOM 状态全都被浏览器撑开
    });
  },
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: Arial;
}

.header {
  height: 80px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 80px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}
.wechat-contact {
  padding: 10px;
}
.wechat-contact img {
  width: 150px;
  height: 150px;
}
.icon {
  margin-right: 5px;
  margin-left: 5px;
  width: 40px;
  height: 40px;
  background-size: contain;
  background-repeat: no-repeat;
  cursor: pointer;
}
.icon-list {
  display: flex;
  justify-content: center;
}
.icon-whatsapp {
  background-image: url("../../public/svg/whatsapp.svg");
}
.icon-facebook {
  background-image: url("../../public/svg/Facebook.svg");
}
.icon-tiktok {
  background-image: url("../../public/svg/tiktoklogo_tiktok.svg");
}
.icon-instagram {
  background-image: url("../../public/svg/instagram.svg");
}
.logo-list {
  display: flex;
  justify-content: center;
}
.logo-text {
  height: 70px;
  display: flex;
  align-items: center;
  font-size: 28px;
  font-weight: bold;
}

.logo {
  background-size: contain;
  background-repeat: no-repeat;
  height: 70px;
  width: 70px;
  background-image: url("../../public/HaoXinlogo.png");
}

.nav {
  display: flex;
  list-style: none;
}

.nav li {
  margin: 0 25px;
  cursor: pointer;
}

.quote-btn {
  background: #0056ff;
  color: #fff;
  border: none;
  padding: 12px 30px;
  border-radius: 6px;
}

.banner {
  height: 600px;
  background: url("../../public/HOME.png");
  display: flex;
  align-items: center;
  justify-content: center;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
}

.banner-content {
  width: 600px;
  margin-left: 100px;
  color: #fff;
}

.banner h1 {
  font-size: 60px;
}

.banner p {
  margin: 25px 0;
  line-height: 30px;
}

.banner button {
  background: #ff6b00;
  color: #fff;
  border: none;
  padding: 15px 35px;
}

.section {
  padding: 40px;
  margin-bottom: 30px;
}

.section h2 {
  text-align: center;
  margin-bottom: 50px;
}
.category-list-box {
  max-height: 740px;
  overflow: auto;
  scrollbar-width: none;
  padding: 20px;
}
.category-list-box::-webkit-scrollbar {
  display: none;
}
.category-list,
.product-list {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 30px;
}

.product-card:hover {
  box-shadow: 10px 10px 20px rgba(0, 0, 0, 0.3);
}

.category-item,
.product-card {
  text-align: center;
  background: #fff;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
  border-radius: 10px;
  overflow: hidden;
  cursor: pointer;
}

.category-item:hover {
  box-shadow: 10px 10px 20px rgba(0, 0, 0, 0.3);
}

.category-item img {
  width: 100%;
  height: 85%;
}
.product-card img {
  width: 100%;
  height: 75%;
}
.category-item img {
  pointer-events: none;
}
.category-item .item-name {
  display: flex;
  height: 15%;
  align-items: center;
  justify-content: center;
  pointer-events: none;
}

.product-card h3 {
  margin: 20px 0;
}

.product-card p {
  padding: 0 20px;
}

.product-card button {
  margin-top: 20px;
  padding: 10px 25px;
}

.advantage {
  background: #0056ff;
  color: #fff;
  padding: 80px;
}

.advantage h2 {
  text-align: center;
  margin-bottom: 50px;
}

.advantage-list {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 30px;
}

.advantage-item {
  text-align: center;
}

.about {
  display: flex;
  align-items: center;
  gap: 60px;
}
.about-left {
  height: 400px;
  background: url("../../public/fact.png");
  display: flex;
  align-items: center;
  justify-content: center;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
}
.about-left,
.about-right {
  flex: 1;
}

.about img {
  width: 100%;
}

.about button {
  margin-top: 30px;
  padding: 12px 30px;
}

.contact {
  padding: 30px;
  background: #f5f5f5;
}

.contact h2 {
  text-align: center;
  margin-bottom: 0px;
}

.contact-box {
  width: 700px;
  margin: auto;
  display: flex;
  flex-direction: column;
}

.contact-box input,
.contact-box textarea {
  margin-bottom: 20px;
  padding: 15px;
}

.contact-box textarea {
  height: 150px;
}

.contact-box button {
  padding: 15px;
  background: #0056ff;
  color: #fff;
  border: none;
}

.footer {
  text-align: center;
  padding: 30px;
  background: #222;
  color: #fff;
}

@media (max-width: 768px) {
  .header {
    padding: 20px;
  }

  .nav {
    display: none;
  }

  .category-list,
  .product-list,
  .advantage-list {
    grid-template-columns: repeat(1, 1fr);
  }

  .about {
    flex-direction: column;
  }

  .contact-box {
    width: 100%;
  }
  .banner {
    height: 300px;
  }
  .banner-content {
    margin: 20px;
  }

  .banner h1 {
    font-size: 36px;
  }
}
</style>
